var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dp"},[(_vm.$vuetify.breakpoint.mobile)?_c('DashboardMobile'):_c('Dashboard2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }